<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Frame } from '#library/components.schema.build.ts'

	interface Props {
		blok: Blok<Frame>
	}

	let { blok }: Props = $props()
</script>

<section class="frame {blok.theme}" {...attrs(blok)}>
	<div class="contain">
		<!-- svelte-ignore a11y_missing_attribute -->
		<iframe
			class="iframe"
			class:fill={!blok.aspect}
			src={blok.link?.url}
			style:aspect-ratio={blok?.aspect}
			allowfullscreen
		></iframe>
	</div>
</section>

<style lang="css">
	.frame {
		background-color: var(--c-background);
		color: var(--c-foreground);
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));
	}

	.contain {
		display: flex;
		justify-content: center;
	}

	.iframe {
		&.fill {
			aspect-ratio: 1;
			height: 90vh;
		}
	}
</style>
